<div class="col-12-nav">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <div class="col-12 img-bg pl-5 pr-5">
        <div class="text-right mt-1">
            <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="functionsService.useLanguage('en')">EN <span class="sr-only">Change language to English</span></a>
            <a tabindex="0" id="es" class="btn btn-default" (click)="functionsService.useLanguage('es')">ES <span class="sr-only">Cambiar idioma a español</span></a>
        </div>
<h3>{{ 'terms-of-service.title' | translate }}</h3>

<br /><br />

<p>{{ 'terms-of-service.welcome_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-acceptance' | translate }}</h5>
<p>{{ 'terms-of-service.acceptance_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-modification' | translate }}</h5>
<p>{{ 'terms-of-service.modification_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.modification_paragraph2' | translate }}</p>

<h5>{{ 'terms-of-service.header-registration' | translate }}</h5>
<p>{{ 'terms-of-service.registration_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.registration_paragraph2' | translate }}</p>
<p>{{ 'terms-of-service.registration_paragraph3' | translate }}</p>
<p>{{ 'terms-of-service.registration_paragraph4' | translate }}</p>

<h5>{{ 'terms-of-service.header-use' | translate }}</h5>
<p>{{ 'terms-of-service.use_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.use_paragraph2' | translate }}</p>

<h5>{{ 'terms-of-service.header-prohibited' | translate }}</h5>

<p>{{ 'terms-of-service.prohibited_intro' | translate }}</p>

<ol type="A">
  <li>{{ 'terms-of-service.prohibited_a' | translate }}</li>

  <li>
    {{ 'terms-of-service.prohibited_b' | translate }}
    <ul>
      <li>{{ 'terms-of-service.prohibited_b_1' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_2' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_3' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_4' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_5' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_6' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_7' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_8' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_9' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_10' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_11' | translate }}</li>
      <li>{{ 'terms-of-service.prohibited_b_12' | translate }}</li>
    </ul>
  </li>

  <li>{{ 'terms-of-service.prohibited_c' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_d' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_e' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_f' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_g' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_h' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_i' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_j' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_k' | translate }}</li>
  <li>{{ 'terms-of-service.prohibited_l' | translate }}</li>
</ol>

<p>{{ 'terms-of-service.prohibited_enforcement_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.prohibited_enforcement_paragraph2' | translate }}</p>
<p>{{ 'terms-of-service.prohibited_enforcement_paragraph3' | translate }}</p>

<h5>{{ 'terms-of-service.header-termination' | translate }}</h5>
<p>{{ 'terms-of-service.termination_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-warranty' | translate }}</h5>
<p>{{ 'terms-of-service.warranty_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-release' | translate }}</h5>
<p>{{ 'terms-of-service.release_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-limitation' | translate }}</h5>
<p>{{ 'terms-of-service.limitation_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.limitation_paragraph2' | translate }}</p>

<ul>
  <li>{{ 'terms-of-service.limitation_list_1' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_2' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_3' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_4' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_5' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_6' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_7' | translate }}</li>
  <li>{{ 'terms-of-service.limitation_list_8' | translate }}</li>
</ul>

<p>{{ 'terms-of-service.limitation_paragraph3' | translate }}</p>

<h5>{{ 'terms-of-service.header-indemnification' | translate }}</h5>
<p>{{ 'terms-of-service.indemnification_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-privacy' | translate }}</h5>
<p>{{ 'terms-of-service.privacy_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.privacy_paragraph2' | translate }}</p>

<h5>{{ 'terms-of-service.header-external-sites' | translate }}</h5>
<p>{{ 'terms-of-service.external_sites_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-license' | translate }}</h5>
<p>{{ 'terms-of-service.license_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.license_paragraph2' | translate }}</p>
<p>{{ 'terms-of-service.license_paragraph3' | translate }}</p>

<h5>{{ 'terms-of-service.header-copyright' | translate }}</h5>
<p>{{ 'terms-of-service.copyright_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-dmca' | translate }}</h5>
<p>{{ 'terms-of-service.dmca_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.dmca_paragraph2' | translate }}</p>
<p>{{ 'terms-of-service.dmca_contact' | translate }}</p>

<h5>{{ 'terms-of-service.header-geographic' | translate }}</h5>
<p>{{ 'terms-of-service.geographic_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-location-info' | translate }}</h5>
<p>{{ 'terms-of-service.location_info_paragraph1' | translate }}</p>
<p>{{ 'terms-of-service.location_info_paragraph2' | translate }}</p>
<p>{{ 'terms-of-service.location_info_paragraph3' | translate }}</p>

<h5>{{ 'terms-of-service.header-no-refunds' | translate }}</h5>
<p>{{ 'terms-of-service.no_refunds_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-entire-agreement' | translate }}</h5>
<p>{{ 'terms-of-service.entire_agreement_paragraph1' | translate }}</p>

<h5>{{ 'terms-of-service.header-governing-law' | translate }}</h5>
<p>{{ 'terms-of-service.governing_law_paragraph1' | translate }}</p>


<h5>{{'terms_service.twenty_first_title' | translate}}</h5>
<ul>
    <li>{{'terms_service.twenty_first_1' | translate}}</li>
    <li>{{'terms_service.twenty_first_2' | translate}}</li>
    <li>{{'terms_service.twenty_first_3' | translate}}</li>
    <li>{{'terms_service.twenty_first_4' | translate}}</li>
    <li>{{'terms_service.twenty_first_5' | translate}}</li>
    <li>{{'terms_service.twenty_first_6' | translate}}<a [href]="privacyPolicyUrl">{{ privacyPolicyUrl }}</a></li>
</ul>

        <div class="p-4 text-center small">©2025 Alertia. {{'general.all_rights' | translate}} - Version 1.2.0</div>
    </div>
</div>


